module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-800italic.e1b52a7bd83e2324db6d92bdc206844c.woff2";